import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';

const classButtonInactive = 'btn btn-default close-modal btn-block';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';

class ModalFollowAnonymous extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal("FollowAnonymous");
  }

  onLogin() {
    window.location = ClaroUrlBuilder.login();
  }

  onRegister() {
    window.location = ClaroUrlBuilder.register(this.props.user.region);
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) return this.closeModal();
    const scope = this;
    return cb(scope);
  }

  render() {
    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>x</Button>
          <h2 className='modal-title text-center'>
            {converter.convertApaUnicode(this.props.translations, 'social_title_ups', '¡Ups!')}
          </h2>
        </Modal.Header>
        <Modal.Body className='text-center success'>
          <p className='padding-top-2'>
            {converter.convertApaUnicode(this.props.translations, 'social_modal_anonymous', 'Para poder seguir usuarios necesitas iniciar sesión o registrarte.')}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6 padding-top-05">
              <Button
                className={ classButtonInactive }
                onClick={ (e) => this.onAccept(e, this.props.onAccept)}>
                {converter.convertApaUnicode(this.props.translations, 'registro_aceptar', 'Aceptar')}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalFollowAnonymous);
